import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientById, getSupersetDashboards, getUserProjects } from '../../Redux/actions';
import { useParams } from 'react-router-dom';
import  { SustDashboard } from './SupersetDashboard';
import { Button, Checkbox, CircularProgress, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { ETP_ENERGY_TAGS, ETP_OPEX_COST_TAGS, ETP_WATER_BALANCE_TAGS, STP_ENERGY_TAGS, STP_OPEX_COST_TAGS, STP_WATER_BALANCE_TAGS,
    STP_WQPI_TAGS, WTP_ENERGY_TAGS, WTP_WATER_BALANCE_TAGS, WTP_WQPI_TAGS } from '../../utils';
import { inputLabelFocusedStyle, selectFocusedStyle, checkboxStyle, buttonStyles } from '../../theme/formStyles';

export default function ESGView() {
    const dispatch = useDispatch();
    const { client_id } = useParams();
    const state = useSelector(st => st);
    const { supersetDashboards, userProjectsList } = state
    const [selectedFacilities, setSelectedFacilities] = useState([]);
    const [clientFacilities, setClientFacilities] = useState([])
    const [dashboardList, setDashboardList] = useState([])
    const [selectedDashboards, setSelectedDashboards] = useState([])
    const [selectedProjects, setSelectedProjects] = useState([])
    const [userProjects, setUserProjects] = useState([])
    const [projectList, setProjectList] = useState([])
    const [showDashboard, setShowDashboard] = useState(true);
    const [loadDashboard, setLoadDashboard] = useState(false);
    const [clientFound, setClientFound] = useState(true);
    const [tagTextDashboardList, setTagTextDashboardList] = useState([]); 

    const [submittedFacilities, setSubmittedFacilities] = useState([]); 
    const [submittedProjects, setSubmittedProjects] = useState([]); 
    const [submittedDashboards, setSubmittedDashboards] = useState([]); 
    const [renderedGraphsCount, setRenderedGraphsCount] = useState(0);
    const [dashboardChange, setDashboardChange] = useState(false);

    const initialDashboardList = [
        'STP Water Balance', 'STP Energy Index (KW/KL)', 'STP OPEX Cost Index (INR/KL)'
    ]
    const dashboardTagMapping = {
        'STP Water Balance': STP_WATER_BALANCE_TAGS,
        'STP Energy Index (KW/KL)': STP_ENERGY_TAGS,
        'STP OPEX Cost Index (INR/KL)': STP_OPEX_COST_TAGS,
        'STP Water Quality Parameters Index (%)': STP_WQPI_TAGS,
        'WTP Water Balance': WTP_WATER_BALANCE_TAGS,
        'WTP Energy Index (KW/KL)': WTP_ENERGY_TAGS,
        'WTP Water Quality Parameters Index (%)': WTP_WQPI_TAGS,
        'ETP Water Balance': ETP_WATER_BALANCE_TAGS,
        'ETP Energy Index': ETP_ENERGY_TAGS,
        'ETP OPEX Cost Index': ETP_OPEX_COST_TAGS,
    };

    const dashboardNames = [
        {"value": "7b70851b-8aee-4bac-af51-c11a63353e81", "label": "System Dashboard", "id": 16},
        {"value": "0db7d1d5-0247-46f8-87ac-dbe8754cf8bc", "label": "Home - Custom Dashboard", "id": 51},
        {"value": "9931b2d3-b110-4f10-a164-af802d0b49fa", "label": "ESG - STP Water Balance", "id": 19},
        {"value": "fbe4f414-8001-4442-a9ab-80025d0b5490", "label": "ESG - WTP Water Quality Parameters Index (%)", "id": 24},
        {"value": "89dfdd00-6321-4115-82fb-4b7c2a887db2", "label": "ESG - STP Energy Index (KW/KL)", "id": 23},
        {"value": "cd4ec559-97fa-43a5-8331-4f5987849f96", "label": "ESG - STP OPEX Cost Index (INR/KL)", "id": 22},
        {"value": "a660af0a-f23e-4ebd-904e-e3f1c1fcdcbf", "label": "ESG - WTP Energy Index (KW/KL)", "id": 21},
        {"value": "481cdaf5-4073-4ea7-9c8d-3ed3267745ed", "label": "ESG - ETP OPEX Cost Index", "id": 31},
        {"value": "40ea467a-c0b2-4db6-96bf-d2052ce643b8", "label": "ESG - ETP Water Balance", "id": 30},
        {"value": "ece4d126-5c2f-4541-a6f3-d93619fadfe2", "label": "ESG - ETP Energy Index", "id": 29},
        {"value": "91f3c2f4-f983-4c48-9b86-6f692deacc74", "label": "ESG - WTP Water Balance", "id": 20},
        {"value": "12da7485-484f-41d9-924a-05621d616332", "label": "ESG - STP Water Quality Parameters Index (%)","id": 25}
    ]

    useEffect(() => {
        
        if (
            selectedFacilities.length > 0 &&
            selectedProjects.length > 0 &&
            selectedDashboards.length > 0 &&
            submittedFacilities.length === 0 &&
            submittedProjects.length === 0 &&
            submittedDashboards.length === 0
        ) {
            setSubmittedFacilities([...selectedFacilities]);
            setSubmittedProjects([...selectedProjects]);
            const tagKeysInOrder = Object.keys(dashboardTagMapping);

            const formattedDashboards = selectedDashboards.map((uuid) => {
            const dashboard = dashboardList.find(d => d.value === uuid);
            const label = dashboard?.label;
            const position = tagKeysInOrder.indexOf(label);
            return {
                key: uuid,
                position,
              };
            });

            setSubmittedDashboards(formattedDashboards);
        }
    }, [selectedFacilities, selectedProjects, selectedDashboards]);
    useEffect(() => {
        dispatch(getUserProjects(client_id)).then((resp) => {
            const response = resp?.data?.data
            if (!response) {
                return
            }
            setProjectList(response);
        });
        dispatch(getClientById(client_id)).then((resp) => {
            const response = resp?.data?.data
            if (!response) {
                setClientFound(false)
                return
            }
            const facilityList = response?.facilities || [];
            if (facilityList?.length > 0) {
                setClientFacilities(facilityList)
                const facilityIds = facilityList.map(facility => facility.id);
                setSelectedFacilities(facilityIds);
            }
        });
    }, [1]);

    useEffect(() => {
        if (projectList?.length > 0 && selectedFacilities?.length > 0) {
            const facilityProjects = projectList.filter(item => selectedFacilities.includes(item?.facilities?.id));
            setUserProjects(facilityProjects);
    
            if (facilityProjects?.length > 0) {
                const projectIds = facilityProjects.map(project => project.pid);
                setSelectedProjects(projectIds);
            } else {
                setSelectedProjects([]);
            }
        }
    }, [selectedFacilities, projectList])

    useEffect(() => {
        if (selectedProjects.length === 0) 
            return;
        const init = async () => {
            const dashboards = dashboardNames.map(({ value, label, id }) => ({
                id,
                value,
                label: label.replace('ESG - ', '')
            }));
    
            const sortedDashboards = dashboards.sort((a, b) => {
                const indexA = Object.keys(dashboardTagMapping).indexOf(a.label);
                const indexB = Object.keys(dashboardTagMapping).indexOf(b.label);
                return indexA - indexB;
            });
    
            setDashboardList(sortedDashboards);
    
            const initialSelected = sortedDashboards
                .filter(d => initialDashboardList.includes(d.label))
                .map(d => d.value);
            setSelectedDashboards(initialSelected);
    
            if (selectedProjects.length > 0) {
                let meterTags = new Set();
                selectedProjects.forEach(pid => {
                    const project = userProjects.find(proj => proj.pid === pid);
                    project?.projectMeter?.forEach(item => {
                        item?.meter?.tags?.forEach(tag => meterTags.add(tag.tag_text));
                    });
                });
    
                const uniqueMeterTags = Array.from(meterTags);
                const newDashboardList = sortedDashboards.filter(dashboard => {
                    const tags = dashboardTagMapping[dashboard.label] || [];
                    return tags.some(tag => uniqueMeterTags.includes(tag));
                });
    
                const filteredDashboardList = initialSelected.filter(value =>
                    newDashboardList.find(item => item.value === value)
                );
    
                setTagTextDashboardList(newDashboardList);
                setSelectedDashboards(filteredDashboardList);
            }
        };
    
        init();
    }, [selectedProjects, userProjects]);

    const handleDbChange = (event, name) => {
        setDashboardChange(true)
        const { target: { value } } = event;
    
        const stateMapping = {
            facility: {
                allItems: clientFacilities?.map(facility => facility.id),
                selectedItems: selectedFacilities,
                setSelected: setSelectedFacilities,
                allLabel: "Select All"
            },
            project: {
                allItems: userProjects?.map(project => project.pid),
                selectedItems: selectedProjects,
                setSelected: setSelectedProjects,
                allLabel: "Select All"
            },
            dashboard: {
                allItems: tagTextDashboardList?.map(dashboard => dashboard.value),
                selectedItems: selectedDashboards,
                setSelected: setSelectedDashboards,
                allLabel: "Select All"
            }
        };
    
        const { allItems, selectedItems, setSelected, allLabel } = stateMapping[name];
    
        if (value.includes(allLabel)) {
            if (selectedItems.length === allItems.length) {
                setSelected([]);
            } else {
                setSelected(allItems);
            }
        } else {
            const newValue = typeof value === 'string' ? value.split(',') : value;
            const filteredValue = newValue.filter(item => item !== allLabel);
            setSelected(filteredValue);
        }

        if (selectedProjects.length === 0 || selectedFacilities.length === 0 || selectedDashboards.length === 0) {
            setShowDashboard(false);
        }
    };

    const handleShowDashboard = () => {
        setRenderedGraphsCount(0); 
        setDashboardChange(false)
        setSubmittedFacilities([...selectedFacilities]);
        setSubmittedProjects([...selectedProjects]);
        const tagKeysInOrder = Object.keys(dashboardTagMapping);

        const formattedDashboards = selectedDashboards.map((uuid) => {
        const dashboard = dashboardList.find(d => d.value === uuid);
        const label = dashboard?.label;
        const position = tagKeysInOrder.indexOf(label);
        return {
            key: uuid,
            position,
          };
        });

        setSubmittedDashboards(formattedDashboards);
        setShowDashboard(true);
        setLoadDashboard(prev => !prev);
    };

    const handleClearFilter = () => {
        setSelectedFacilities([]);
        setSelectedProjects([]);
        setSelectedDashboards([]);
        setSubmittedFacilities([]);
        setSubmittedProjects([]);
        setSubmittedDashboards([]);
        setShowDashboard(false);
    };

    const handleShowDashboardDropdown = () => {
        return <FormControl  size='small' sx={{ width: '100%' }}>
            <InputLabel id="chart" sx={inputLabelFocusedStyle}>Dashboard*</InputLabel>
            <Select
                labelId="chart"
                id="chartId"
                className='white-bg'
                multiple
                disabled={selectedProjects?.length === 0 || selectedFacilities?.length === 0}
                sx={selectFocusedStyle}
                MenuProps={{
                    autoFocus: false,
                    disableScrollLock: true,
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                    PaperProps: {
                        style: {
                            maxHeight: 350,
                            overflowY: "auto",
                            width: '100%',
                            maxWidth: 260
                        },
                    },
                }}
                value={selectedDashboards}
                onChange={(e) => handleDbChange(e, 'dashboard')}
                input={<OutlinedInput label="Dashboard" />}
                renderValue={(selected) => selected.length == tagTextDashboardList?.length ? 'All Dashboards' : selected.length + ' selected '}
            >
                {(selectedProjects?.length > 0 && tagTextDashboardList?.length > 0 ) && (<MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}} value="Select All">
                    <Checkbox sx={checkboxStyle} checked={selectedDashboards?.length === tagTextDashboardList?.length} indeterminate={selectedDashboards?.length > 0 && selectedDashboards?.length < tagTextDashboardList?.length} />
                    <ListItemText primary="Select All" />
                </MenuItem>)}
                {selectedProjects?.length > 0 && tagTextDashboardList?.map((db) => (
                        <MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal', display: 'flex', alignItems: 'flex-start'}} key={db.value} label={db.label} value={db.value}>
                            <Checkbox sx={checkboxStyle} style={{ paddingTop: '0px'}} checked={selectedDashboards?.includes(db.value)} />
                            <ListItemText primary={db.label} />
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    }

    if (supersetDashboards?.isFetching) {
        return (
            <div className="main w3-padding-large">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <h5 style={{ color: '#004d4d'}} className="card-title">Sustainability Dashboard</h5>
                    </Grid>
                    <div className='w3-center' style={{ marginTop: 30 }}>
                        <CircularProgress />
                    </div>
                </Grid>
            </div>
        )
    }
    const isSubmitDisabled = 
        selectedFacilities?.length === 0 || 
        selectedDashboards?.length === 0 || 
        selectedProjects?.length === 0 || 
        (!dashboardChange && (renderedGraphsCount < selectedDashboards?.length));

    if (!clientFound) {
        return <Grid container justifyContent={"center"} style={{ marginTop: '160px' }}>
            <h5 className='w3-text-grey'>  No Data Found</h5>
        </Grid>
    }

    return (
        <div className="main w3-padding-large">
            <div>
                <Grid container spacing={2}>
                    <Grid item className='w3-margin-bottom'>
                        <h5 style={{ color: '#004d4d'}} className="card-title">Sustainability Dashboard</h5>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className='w3-margin-bottom'>
                    <Grid item md={3}>
                        <FormControl size='small' sx={{ width: '100%' }}>
                            <InputLabel id="facility" sx={inputLabelFocusedStyle}>Facility*</InputLabel>
                            <Select
                                labelId="facility"
                                id="facilityId"
                                className='white-bg'
                                multiple
                                sx={selectFocusedStyle}
                                MenuProps={{
                                    autoFocus: false,
                                    disableScrollLock: true,
                                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                    transformOrigin: { vertical: "top", horizontal: "left" },
                                    getContentAnchorEl: null,
                                    PaperProps: {
                                        style: {
                                            maxHeight: 350,
                                            overflowY: "auto",
                                            width: '100%',
                                            maxWidth: 260
                                        },
                                    },
                                }}
                                value={selectedFacilities}
                                onChange={(e) => handleDbChange(e, 'facility')}
                                input={<OutlinedInput label="Facility" />}
                                renderValue={(selected) => selected.length == clientFacilities?.length ? 'All Facilities' : selected.length + ' selected '}
                            >
                                {(clientFacilities?.length > 0) && (<MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}} value="Select All">
                                    <Checkbox sx={checkboxStyle} checked={selectedFacilities?.length === clientFacilities?.length} indeterminate={selectedFacilities?.length > 0 && selectedFacilities?.length < clientFacilities?.length} />
                                    <ListItemText primary="Select All" />
                                </MenuItem>)}
                                {clientFacilities?.map((fac) => (
                                    <MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal', display: 'flex', alignItems: 'flex-start'}} key={fac.id} label={fac.facility_name} value={fac.id}>
                                        <Checkbox sx={checkboxStyle} style={{ paddingTop: '0px'}} checked={selectedFacilities?.includes(fac.id)} />
                                        <ListItemText primary={fac.facility_name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={3} >
                        <FormControl size='small' sx={{ width: '100%' }}>
                            <InputLabel id="chart" sx={inputLabelFocusedStyle}>Project*</InputLabel>
                            <Select
                                labelId="chart"
                                id="chartId"
                                className='white-bg'
                                multiple
                                disabled={selectedFacilities?.length === 0}
                                sx={selectFocusedStyle}
                                MenuProps={{
                                    autoFocus: false,
                                    disableScrollLock: true,
                                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                    transformOrigin: { vertical: "top", horizontal: "left" },
                                    getContentAnchorEl: null,
                                    PaperProps: {
                                        style: {
                                            maxHeight: 350,
                                            overflowY: "auto",
                                            width: '100%',
                                            maxWidth: 260
                                        },
                                    },
                                }}
                                value={selectedProjects}
                                onChange={(e) => handleDbChange(e, 'project')}
                                input={<OutlinedInput label="Project" />}
                                renderValue={(selected) => selected.length == userProjects?.length ? 'All Projects' : selected.length + ' selected '}
                            >
                                {(userProjects?.filter((item) => selectedFacilities?.includes(item.facilities.id))?.length > 0 )&& (<MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}} value="Select All">
                                    <Checkbox sx={checkboxStyle} checked={selectedProjects?.length === userProjects?.length} indeterminate={selectedProjects?.length > 0 && selectedProjects?.length < userProjects?.length} />
                                    <ListItemText primary="Select All" />
                                </MenuItem>)}
                                {userProjects?.filter((item) => selectedFacilities?.includes(item.facilities.id)).map((proj) => (
                                    <MenuItem style={{wordWrap: 'break-word', whiteSpace: 'normal', display: 'flex', alignItems: 'flex-start'}}  key={proj.pid} label={proj.projname} value={proj.pid}>
                                        <Checkbox sx={checkboxStyle} style={{ paddingTop: '0px'}} checked={selectedProjects?.includes(proj.pid)} />
                                        <ListItemText primary={proj.projname.replace("WA-", "").trim()} />
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={3}>
                        {handleShowDashboardDropdown()}
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            size='small'
                            sx={{cursor: isSubmitDisabled ? 'not-allowed' : 'pointer', height: '98%', ...buttonStyles.contained}}
                            onClick={handleShowDashboard}
                            disabled={isSubmitDisabled}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            size='small'
                            sx={{height: '98%', ...buttonStyles.outlined}}
                            onClick={handleClearFilter}
                            disabled={!(selectedFacilities?.length > 0 || selectedProjects?.length > 0 || selectedDashboards?.length > 0)}
                        >
                            Clear
                        </Button>
                    </Grid>
                </Grid>
            </div>
            {selectedFacilities?.length === 0 && (
                <div>
                    Select a facility from the dropdown to view Sustainability Dashboard
                </div>
            )}
            {(selectedProjects?.length === 0) && (
                selectedFacilities?.length === 0 ? (
                    <div>
                        Select a facility to view the available projects
                    </div>) : (
                    <div>
                        Select a project from the dropdown to view Sustainability Dashboard
                    </div>
                )
            )}
            {(selectedDashboards?.length === 0) && (
                <div>
                    Select a dashboard from the dropdown to view Sustainability Dashboard
                </div>
            )}

            {(selectedFacilities?.length > 0 && selectedDashboards?.length > 0 && selectedProjects?.length > 0 && showDashboard) &&
                <SustDashboard
                    facility_ids={submittedFacilities}
                    dashboardList={submittedDashboards}
                    projectList={submittedProjects}
                    client_id={client_id}
                    dashboardType='ESG' 
                    onGraphRendered={() => setRenderedGraphsCount(prev => prev + 1)}
                    isSubmitDisabled={isSubmitDisabled}
                />
            }
        </div>
    )
}